/** @jsx jsx */
import { jsx } from '@emotion/core';
import { itemWrapperStyles, separatorStyles } from '../internal/styles';
import Button from './Button';

var noop = function noop() {};

var EllipsisItem = function EllipsisItem(props) {
  var _props$hasSeparator = props.hasSeparator,
      hasSeparator = _props$hasSeparator === void 0 ? false : _props$hasSeparator,
      _props$onClick = props.onClick,
      onClick = _props$onClick === void 0 ? noop : _props$onClick,
      testId = props.testId;
  return jsx("div", {
    css: itemWrapperStyles
  }, jsx(Button, {
    testId: testId,
    onClick: onClick
  }, "\u2026"), hasSeparator ? jsx("div", {
    css: separatorStyles
  }, "/") : null);
};

export default EllipsisItem;